import { useActionCallback } from "@easybiz/hook";
import { JOB_ACTION_RESCHEDULE, OPERATION_GROUP_JOB } from "@easybiz/utils";
import { useCallback } from "react";
import { useIntl } from "react-intl";

function useJobReschedule(callback) {
  const intl = useIntl();

  const onSubmit = useCallback(({ taskId, optionsId, schedule, returnSchedule, option, worker, note, address }) => {
    return [
      OPERATION_GROUP_JOB,
      JOB_ACTION_RESCHEDULE,
      {
        ...(optionsId && { optionsId }),
        ...(schedule && { schedule }),
        ...(option && { option }),
        ...(worker && { worker }),
        ...(note && { note }),
        ...(address && { address }),
        ...(returnSchedule && { returnSchedule }),
        taskId,
      },
    ];
  }, []);

  return useActionCallback(onSubmit, callback, intl.formatMessage({ defaultMessage: "Rescheduled" }));
}

export default useJobReschedule;
